import React from 'react';
import DefaultImage from 'images/defaultAndEmpties/defaultAndEmptyMediumImageRectangleLightGrayBg.svg';
import ExtractIcon from 'images/icons/objects/clocks/clockArrowBackLightBlueWhiteBgRoundedLightBlueBorder.svg';
import moment from 'moment/moment';
import {
  ProductCardContainer,
  ProductTopInfos,
  ProductBottomInfos
} from '../../../styles';
import ValidationLength from 'utils/utils';
import { IconButton, useMediaQuery } from '@material-ui/core';

function ProductCard({
  product,
  setModalSettings,
  modalSettings,
  isLabelAdmin,
  labelManagerHasAllPermissions,
  isLabelUser
}) {
  const isMobileScreen = useMediaQuery('(max-width: 866px)');
  const isSmallTablet = useMediaQuery('(max-width: 602px)');
  const isPhoneScreen = useMediaQuery('(max-width: 576px)');
  const labelCountObj = [
    {
      type: 'expired',
      count: product?.expiredCount
    },
    {
      type: 'onDate',
      count: product?.onDateCount
    },
    {
      type: 'valid',
      count: product?.validCount
    }
  ];

  const getDescriptionLimit = () => {
    if (isPhoneScreen) return 70;
    if (isSmallTablet) return 50;
    return 35;
  };

  const handleOpenPrintLabelConfig = () => {
    setModalSettings(
      modalSettings.map((modal) =>
        modal.name === 'labelPrintConfigDialog'
          ? { ...modal, open: true, product }
          : modal
      )
    );
  };

  return (
    <ProductCardContainer>
      <ProductTopInfos onClick={() => handleOpenPrintLabelConfig()}>
        <span className="title bold mr10">
          {ValidationLength(product?.description, getDescriptionLimit())}
        </span>

        <img
          src={product?.image?.url || DefaultImage}
          alt={product?.image?.url}
          width="80px"
          height="58px"
        />
      </ProductTopInfos>

      <ProductBottomInfos>
        <div
          onClick={() => {
            handleOpenPrintLabelConfig();
          }}
          className={`conservationInfo ${
            !product?.conservation && 'visibilityHidden'
          }`}
        >
          <span className="quantityValidDays">
           {product?.quantityValidDays} {product?.quantityValidDays === 1 ? 'dia' : 'dias'}
          </span>

          <span>
            {ValidationLength(
              isMobileScreen
                ? product?.conservation?.abbreviation
                : product?.conservation?.description,
              20
            )}
          </span>
        </div>

        <div className="bottomRightContainer">
          <div
            onClick={() => {
              handleOpenPrintLabelConfig();
            }}
            className={`labelCountContainer justifyCenter ${product?.labelStatus?.toLowerCase()}`}
          >
            {labelCountObj?.map((label) => (
              <div
                className={`labelCountItem ${label?.count && 'hasValue'} ${
                  label?.type
                }`}
              >
                <span>{label?.count || '-'}</span>
              </div>
            ))}
          </div>
          
          {!isLabelAdmin &&
            <IconButton
              onClick={() => {
                setModalSettings(
                  modalSettings.map((modal) =>
                    modal.name === 'stockExtractDialog'
                      ? {
                          ...modal,
                          initialProduct: product || null,
                          open: true
                        }
                      : modal
                  )
                );
              }}
              style={{ padding: 0, outline: 0 }}
            >
              <img src={ExtractIcon} alt="ExtractIcon" />
            </IconButton>
          }
        </div>
      </ProductBottomInfos>
    </ProductCardContainer>
  );
}

export default ProductCard;
